import React from 'react';
import { createPortal } from 'react-dom';
import './index.scss';

export default function Modal({ visible, title, onClose, footer, children }) {
  if (!visible) return null;
  return createPortal(
    <div className="c-modal-mask" onClick={onClose}>
      <div className="c-modal" onClick={e => e.stopPropagation()}>
        <div className="c-modal-header">
          <span className="c-modal-title">{title}</span>
          <button className="c-modal-close" onClick={onClose}>✕</button>
        </div>
        <div className="c-modal-body">{children}</div>
        {footer && <div className="c-modal-footer">{footer}</div>}
      </div>
    </div>,
    document.body
  );
} 